export default "__VITE_ASSET__Cjv4WmpA__"